export default function ProjectTOC({ sections }) {
  return (
    <aside className="hidden lg:block fixed right-12 top-40 space-y-3 opacity-60">
      {sections.map((sec) => (
        <a
          key={sec.id}
          href={`#${sec.id}`}
          className="block text-sm hover:opacity-100 transition"
        >
          ● {sec.label}
        </a>
      ))}
    </aside>
  );
}
